import React, { useState, useEffect } from 'react'
import { Row } from 'rsuite'
import AttachFilesWidget from './AttachFilesWidget'
import InputForm from '../../components/forms/input/InputForm'

export default function ProjectEvaluationWidget({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)

  return (
    <>
      <Row>
        <InputForm
          schema={schema.projectEvaluation}
          rows={3}
          componentClass="textarea"
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
        />
      </Row>
      <Row style={{ marginTop: 10 }}>
        <AttachFilesWidget
          key={schema.projectEvaluation.name}
          showCommandButton={true}
          schema={schema.attachments}
        />
      </Row>
    </>
  )
}
